/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var _ = require('underscore');
var moment = require('moment');

module.exports = function(searchBody) {
  var deferred = $.Deferred();
  $.soap({
    body: {
      PerformElasticSearch: {
        $xmlns: 'http://dobs.pa.gov/cm/search/bpm/1.0',
        IndexName: 'co-event',
        SearchBody: JSON.stringify(searchBody)
      }
    },
    blueprint: {
      searchResults: '$..Response'
    }
  })
    .done(function(result) {
      var searchResult = JSON.parse(result.searchResults);
      var hits = _.map(searchResult.hits.hits, function(hit) {
        var result = hit._source;
        result.eventId = result.eventId || '--';
        result.eventTitle = result.eventTitle || '--';
        result.eventTypeId = result.eventTypeId || '--';
        result.eventType = result.eventTypeName || '--';
        result.venueName = result.venueName || '--';
        result.venueStreetAddress = result.venueStreetAddress || '--';
        result.venueCounty = result.venueCounty || '--';
        result.organizationName = result.organizationName || '--';
        result.presenters = result.presenters || '--';
        result.program1Id = result.program1Id || '--';
        result.program1 = result.program1Name || '--';
        result.isThirdPartyEvent = result.isThirdPartyEvent === 1 ? 'Yes' : 'No';
        if (result.eventStartDateTime) {
          result.eventDate = moment(result.eventStartDateTime, moment.ISO_8601);
        }
        return result;
      });
      var results = {
        hits: hits,
        totalHits: searchResult.hits.total.value,
        took: searchResult.took
      };
      deferred.resolve(results);
    })
    .fail(function(err) {
      deferred.reject(err);
    });

  return deferred.promise();
};
